import React from "react";
import { useContext } from "react";
import { ILocalizationContext } from "../../Localization/Models/ILocalizationContext";
import LocalizationContext from "../../Localization/LanguageContext";
import { Paragraph } from "@saif/paragraph";
import { LandingPage } from "../../Components/LandingPage/LandingPage";
import "./Success.scss";

const Success = () => {
  const { getValue } = useContext(LocalizationContext) as ILocalizationContext;

  return (
    <LandingPage
      iconProps={{
        icon: "paper-plane",
        size: "xxl",
      }}
      headingProps={{
        size: "xl",
        isLoading: false,
        center: true,
        children: getValue("Success", "Title"),
      }}
      description={
        <>
          <Paragraph>
            <div className="success-subtitle">
              {getValue("Success", "TitleSub")}{" "}
            </div>
            <ul>
              <li>
                {getValue("Success", "Bullet1Prefix")}
                <i>{getValue("Success", "Bullet1Middle")}</i>
                {getValue("Success", "Bullet1Suffix")}
              </li>
              <li>{getValue("Success", "Bullet2")}</li>
            </ul>
          </Paragraph>
        </>
      }
    />
  );
};

export default Success;
